<template>
  <v-card elevation="1">
    <v-dialog v-model="sampleModal" max-width="50%">
      <v-card>
        <v-card-title>
          <div class="text-center popupHeadline" style="width: 100%">
            {{ $t("titles.queryOutput") }}
          </div>
        </v-card-title>
        <v-divider class="mb-2" />
        <v-card-text>
          <FormElement
            key="viewName"
            v-model="viewName"
            :validationLabel="$t('labels.viewName')"
            :formLabel="$t('labels.viewName')"
            :formType="{
              name: 'select',
              items: {
                data: viewNames,
                text: 'name',
                value: 'value',
              },
            }"
            :labelShown="false"
            :placeholder="$t('labels.viewName')"
          />
          <v-data-table
            :headers="selectedViewHeaders"
            :items="viewRows"
            hide-default-footer
            :loading="$store.state.loadingStatus"
            :options="{
              itemsPerPage: itemsPerPage,
            }"
            :item-key="'Id'"
            :no-data-text="$t('messages.noDataReports')"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-center" v-for="row in selectedViewHeaders">
                  {{ getRowValue(item, row) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="actionsModal"
      max-width="50%"
      :persistent="isEditMode ? true : false"
    >
      <v-card class="popup-card" elevation="1">
        <v-card-title class="popupHeadline" style="font-size: 24px">
          <div class="text-center popupHeadline" style="width: 100%">
            {{ $t("buttons." + (isEditMode ? "update" : "add")) }}
          </div>
        </v-card-title>
        <v-divider class="mb-4" />

        <ValidationObserver
          ref="actionsOnExhangeRateObserver"
          v-slot="{ handleSubmit }"
        >
          <form @submit.prevent="handleSubmit(submitForm)">
            <v-card-text>
              <v-row>
                <FormElement
                  v-for="(element, index) in formItems"
                  :key="
                    element.key.parent + '_' + element.key.child + '_' + index
                  "
                  v-model="$data[element.key.parent][element.key.child]"
                  :validationLabel="$t(element.validationLabel)"
                  :rules="element.rules"
                  :formLabel="$t(element.formLabel)"
                  :onChange="element.onChange"
                  :formType="element.formType"
                  :lg="element.lg"
                  :cols="element.cols"
                  :disabled="element.disabled"
                  :hidden="element.hidden"
                  :labelShown="element.labelShown"
                  :active="element.active"
                  :topLabel="element.topLabel"
                  :classes="element.classes"
                  :placeholder="$t(element.placeholder)"
                />
                <v-col cols="12" class="d-flex justify-end mt-n8">
                  <v-btn
                    style="color: #fff"
                    elevation="0"
                    color="green"
                    type="button"
                    class="button lighten-1"
                    @click="runQueryInline"
                    :disabled="query.loading"
                  >
                    <v-icon
                      >mdi-table-{{ query.loading ? "off" : "cog" }}</v-icon
                    >
                    {{ $t("buttons.run") }}
                  </v-btn>
                </v-col>
                <v-col>
                  <h3>{{ $t("titles.queryOutput") }}</h3>
                  <v-divider class="mt-4" />
                  <v-data-table
                    :headers="selectedViewHeaders"
                    :items="viewRows"
                    hide-default-footer
                    :loading="query.loading"
                    :options="{
                      itemsPerPage: itemsPerPage,
                    }"
                    :item-key="'Id'"
                    :no-data-text="$t('messages.noDataReports')"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td
                          class="text-center"
                          v-for="row in selectedViewHeaders"
                        >
                          {{ getRowValue(item, row) }}
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: #0077d5;

                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                type="submit"
                :loading="$store.state.loadingStatus"
                >{{ $t("buttons.save") }}</v-btn
              >
              <v-btn
                style="
                  color: #fff;
                  text-transform: unset !important;
                  background-color: var(--red);
                  padding: 1vh 1vh;
                  border-radius: 30px !important;
                  font-weight: bolder;
                  font-size: medium;
                "
                elevation="0"
                class="darken-1"
                @click="
                  actionsModal = false;
                  query.totalItems = [];
                "
                >{{ $t("buttons.cancel") }}</v-btn
              >
            </v-card-actions>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <v-card-title
      v-if="!showItem"
      class="d-flex flex-row"
      style="color: var(--darkBlue)"
    >
      <v-row>
        <v-col class="text-lg-left text-center" lg="12" cols="12">
          <h3>{{ $t("navigationDrawerMenu.adminReports") }}</h3>
        </v-col>
      </v-row>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-3"
              style="font-size: 32px"
              v-bind="attrs"
              v-on="on"
              @click="sampleModal = true"
            >
              mdi-table-question
            </v-icon>
          </template>
          <span>{{ $t("titles.sampleSQLViews") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-3"
              style="font-size: 32px"
              v-bind="attrs"
              v-on="on"
              @click="actionsModal = true"
            >
              mdi-plus-box-outline
            </v-icon>
          </template>
          <span>{{ $t("buttons.add") }}</span>
        </v-tooltip>
        <RefreshButton :refreshFunction="getItems"></RefreshButton>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text v-if="!showItem">
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        :loading="$store.state.loadingStatus"
        :options="{
          itemsPerPage: itemsPerPage,
        }"
        :item-key="'Id'"
        :no-data-text="$t('messages.noDataReports')"
      >
        <template v-slot:item.companyCategory="{ item }">
          {{
            $t(
              `labels.${
                item.CompanyCategory === null
                  ? "admin"
                  : item.CompanyCategory === 1
                  ? "customer"
                  : "supplier"
              }`
            )
          }}
        </template>
        <template v-slot:footer>
          <div class="d-flex justify-center mt-8">
            <v-row align="center" justify="center">
              <v-col
                v-if="
                  $vuetify.breakpoint.md ||
                  $vuetify.breakpoint.lg ||
                  $vuetify.breakpoint.xl
                "
                md="2"
              ></v-col>
              <v-col cols="9" sm="12" md="7" lg="7" xl="7">
                <v-pagination
                  v-if="pageLength > 0"
                  class="my-4"
                  @input="onPageChange"
                  v-model="page"
                  :length="pageLength"
                  :total-visible="10"
                  circle
                ></v-pagination>
              </v-col>
              <v-col
                cols="11"
                sm="11"
                md="3"
                lg="3"
                xl="3"
                class="ml-md-auto d-flex align-center mb-6 mb-md-0 pr-3 pr-md-6"
              >
                <v-select
                  v-model="itemsPerPage"
                  :items="perPageValues"
                  :label="$t('labels.selectItemsPerPage')"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  @change="changeItemsPerPage"
                  rounded
                >
                </v-select>
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="my-10 d-flex flex-column align-center">
            <h4>{{ $t("messages.noData") }}</h4>
          </div>
        </template>
        <!-- eslint-disable -->
        <template v-slot:item.CreatedOnUtc="{ item }">
          {{ item.CreatedOnUtc ? convertToLocal(item.CreatedOnUtc) : "-" }}
        </template>
        <template v-slot:item.Description="{ item }">
          {{
            `${item.Description.substring(0, 50)} ${
              item.Description.length >= 50 ? "..." : ""
            }`
          }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="black"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="download(item)"
                >
                  mdi-download
                </v-icon>
              </template>
              <span>{{ $t("labels.downloadData") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="#29B7B7"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("buttons.update") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="#29B7B7"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="showDetail(item)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>{{ $t("buttons.view") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item.Id)"
                >
                  mdi-trash-can
                </v-icon>
              </template>
              <span class="text-uppercase">{{ $t("buttons.remove") }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.FileUrl" top>
              <template v-slot:activator="{ on, attrs }">
                <a :href="item.FileUrl" target="_blank">
                  <v-icon
                    small
                    class="mr-2 green-icon"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-download
                  </v-icon>
                </a>
              </template>
              <span>{{ $t("buttons.download") }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card-text>

    <v-card-title
      v-if="showItem"
      class="d-flex flex-row"
      style="color: var(--darkBlue)"
    >
      <v-row>
        <v-col
          class="d-flex text-lg-left text-center items-center"
          lg="12"
          cols="12"
        >
          <v-icon
            @click.stop="
              () => {
                selectedItem = null;
                showItem = false;
                startDate = null;
                endDate = null;
                senderCountryId = null;
                senderCityId = null;
                receiverCountryId = null;
                receiverCityId = null;
                senderCities = [];
                receiverCities = [];
                integrationLogisticType = null;
                orderStatus = null;
              }
            "
            style="color: #0177d4; font-size: 32px"
            class="mr-2"
          >
            mdi-arrow-left
          </v-icon>
          <h3>{{ this.selectedItem.Name }}</h3>
        </v-col>
      </v-row>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-3"
              style="font-size: 32px"
              v-bind="attrs"
              v-on="on"
              @click="download(selectedItem)"
            >
              mdi-download
            </v-icon>
          </template>
          <span>{{ $t("buttons.download") }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-divider />
    <v-card-text v-if="showItem">
      <v-row class="px-8 mt-2 mb-4">
        <FormElement
          key="START_DATE_FILTER"
          :vertical="true"
          v-model="startDate"
          hide-details
          :validationLabel="$t('labels.minOrderDate')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'date',
            dateMode: 'date',
          }"
          :placeholder="showShipmentFilters ? $t('labels.minOrderDate') : 'Minimum Tarih'"
          :classes="'mb-3'"
        />
        <FormElement
          key="End_DATE_FILTER"
          :vertical="true"
          v-model="endDate"
          hide-details
          :validationLabel="$t('labels.maxOrderDate')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'date',
            dateMode: 'date',
          }"
          :placeholder="showShipmentFilters ? $t('labels.maxOrderDate') : 'Maximum Tarih'"
          :classes="'mb-3'"
        />
        <FormElement
          v-if="showShipmentFilters"
          key="SENDER_COUNTRY_ID"
          v-model="senderCountryId"
          :vertical="true"
          hide-details
          :validationLabel="$t('labels.senderCountry')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="
            () => {
              this.handleCountryChange(true);
            }
          "
          :formType="{
            name: 'multipleSelect',
            items: {
              data: senderCountries,
              text: 'Name',
              value: 'Id',
            },
          }"
          :placeholder="$t('labels.senderCountry')"
          :classes="'mb-3'"
        />
        <FormElement
          v-if="showShipmentFilters"
          key="SENDER_CITY_ID"
          v-model="senderCityId"
          :vertical="true"
          hide-details
          :validationLabel="$t('labels.senderCity')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: senderCities,
              text: 'Name',
              value: 'Id',
            },
          }"
          :placeholder="$t('labels.senderCity')"
          :classes="'mb-3'"
        />
        <FormElement
          v-if="showShipmentFilters"
          key="RECEIVER_COUNTRY_ID"
          v-model="receiverCountryId"
          :vertical="true"
          hide-details
          :validationLabel="$t('labels.receiverCountry')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="
            () => {
              this.handleCountryChange(false);
            }
          "
          :formType="{
            name: 'multipleSelect',
            items: {
              data: receiverCountries,
              text: 'Name',
              value: 'Id',
            },
          }"
          :placeholder="$t('labels.receiverCountry')"
          :classes="'mb-3'"
        />
        <FormElement
          v-if="showShipmentFilters"
          key="RECEIVER_CITY_ID"
          v-model="receiverCityId"
          :vertical="true"
          hide-details
          :validationLabel="$t('labels.receiverCity')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: receiverCities,
              text: 'Name',
              value: 'Id',
            },
          }"
          :placeholder="$t('labels.receiverCity')"
          :classes="'mb-3'"
        />

        <FormElement
          v-if="showShipmentFilters"
          key="INTEGRATION_LOGISCTIC_TYPE"
          v-model="integrationLogisticType"
          :vertical="true"
          hide-details
          :validationLabel="$t('titles.subsupplier')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="onLogisticChange"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: logistics,
              text: 'Name',
              value: 'Id',
            },
          }"
          :placeholder="$t('titles.subsupplier')"
          :classes="'mb-3'"
        />

        <FormElement
          v-if="showShipmentFilters"
          key="INTEGRATION_LOGISCTIC_SUB_TYPE"
          v-model="integrationLogisticSubType"
          :vertical="true"
          hide-details
          :validationLabel="$t('titles.integrationService')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :active="!!integrationLogisticType"
          :hidden="!integrationLogisticType"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: logisticTypes,
              text: 'value',
              value: 'value',
            },
          }"
          :placeholder="$t('titles.integrationService')"
          :classes="'mb-3'"
        />

        <FormElement
          v-if="showShipmentFilters"
          key="ORDER_STATUS"
          v-model="orderStatus"
          :vertical="true"
          hide-details
          :validationLabel="$t('labels.orderStatus')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: orderStatuses,
              text: 'name',
              value: 'value',
            },
          }"
          :placeholder="$t('labels.orderStatus')"
          :classes="'mb-3'"
        />

        <FormElement
          v-if="showShipmentFilters"
          key="ORDER_PAYMENT_STATUS"
          v-model="orderPaymentStatus"
          :vertical="true"
          hide-details
          :validationLabel="$t('labels.paymentStatus')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: orderPaymentStatuses,
              text: 'name',
              value: 'value',
            },
          }"
          :placeholder="$t('labels.paymentStatus')"
          :classes="'mb-3'"
        />

        <FormElement
          v-if="showShipmentFilters"
          key="CUSTOMER_NAME"
          v-model="customerName"
          :vertical="true"
          hide-details
          :validationLabel="$t('labels.customerName')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'text',
            appendIcon: 'mdi-magnify',
            appendClick: getSearchDebounced,
          }"
          :placeholder="$t('labels.customerName')"
          :classes="'mb-3'"
          @input="getSearchDebounced"
        />

        <FormElement
          v-if="showShipmentFilters"
          key="ORDER_TYPES"
          v-model="orderType"
          :vertical="true"
          hide-details
          :validationLabel="$t('titles.orderType')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: orderTypes,
              text: 'name',
              value: 'value',
            },
          }"
          :placeholder="$t('titles.orderType')"
          :classes="'mb-3'"
        />
        <FormElement
          v-if="showShipmentFilters"
          key="SHIPMENT_CREATE_TYPE"
          v-model="shipmentCreateType"
          :vertical="true"
          hide-details
          :validationLabel="$t('titles.shipmentCreateType')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: shipmentCreateTypes,
              text: 'name',
              value: 'value',
            },
          }"
          :placeholder="$t('titles.shipmentCreateType')"
          :classes="'mb-3'"
        />

        <FormElement
          v-if="showShipmentFilters"
          key="IS_PLANNED"
          v-model="isPlanned"
          :vertical="true"
          hide-details
          :validationLabel="$t('titles.isPlanned')"
          :topLabel="true"
          :labelShown="false"
          :cols="6"
          :xs="6"
          :sm="4"
          :lg="3"
          :xl="2"
          :onChange="runQuery"
          :formType="{
            name: 'multipleSelect',
            items: {
              data: [
                {
                  name: $t('labels.All'),
                  value: -1,
                },
                {
                  name: $t('buttons.yes'),
                  value: true,
                },
                {
                  name: $t('buttons.no'),
                  value: false,
                },
              ],
              text: 'name',
              value: 'value',
            },
          }"
          :placeholder="$t('titles.isPlanned')"
          :classes="'mb-3'"
        />
      </v-row>
      <v-divider />
      <v-card-text>
        <v-data-table
          :headers="selectedViewHeaders"
          :items="viewRows"
          hide-default-footer
          :loading="query.loading"
          :options="{
            itemsPerPage: itemsPerPage,
          }"
          :item-key="'Id'"
          :no-data-text="$t('messages.noData')"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-center" v-for="row in selectedViewHeaders">
                {{ getRowValue(item, row) }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-pagination
          v-if="queryPageLength > 0"
          class="my-4"
          @input="query.onChange"
          v-model="query.page"
          :length="queryPageLength"
          :total-visible="10"
          circle
        ></v-pagination>
      </v-card-text>
    </v-card-text>
  </v-card>
</template>
<script>
import {
  downloadFile,
  getCities,
  getCountries,
  ITEMS_PER_PAGE_OPTIONS,
} from "../utils/constants";
import FormElement from "../components/FormElement.vue";
import RefreshButton from "../components/RefreshButton.vue";
import TabScreen from "../components/TabScreen.vue";
import AnnouncementService from "../services/AnnouncementService";
import AdminReportService from "../services/AdminReportService";
import uploadFile from "../utils/uploadFile";
import CheckTable from "../components/CheckTable.vue";
import IntegrationService from "../services/IntegrationService";
import PortalService from "../services/PortalService";

export default {
  data() {
    return {
      headers: [],
      items: [],
      statuses: [],
      showItem: false,
      selectedItem: null,

      // Filters
      currencyCode: "",
      validityDate: new Date(),

      // States
      itemsPerPage: 10,
      page: 1,
      totalItems: 0,
      perPageValues: [
        {
          name: "5",
          value: 5,
        },
        {
          name: "10",
          value: 10,
        },
        {
          name: "15",
          value: 15,
        },
        {
          name: "30",
          value: 30,
        },
        {
          name: "50",
          value: 50,
        },
        {
          name: "100",
          value: 100,
        },
        {
          name: this.$t("labels.All"),
          value: 9999,
        },
      ],
      isEditMode: false,

      actionsModal: false,
      form: {
        CompanyCategory: null,
      },

      slots: [],
      centralBankExchangeRateList: [],
      selectedTab: 0,
      dateFilter: new Date(),

      file: {
        loading: "",
        data: null,
        url: "",
      },

      isSupplier: null,
      companyCategory: null,

      viewHeaders: [],
      viewName: null,
      sampleModal: false,

      startDate: null,
      endDate: null,
      showShipmentFilters: true,

      senderCountryId: null,
      senderCityId: null,
      receiverCountryId: null,
      receiverCityId: null,

      senderCountries: [],
      senderCities: [],
      receiverCountries: [],
      receiverCities: [],

      integrationLogisticType: null,
      integrationLogisticSubType: null,
      logistics: [
        {
          Name: "FedEx",
          Id: 1,
        },
        {
          Name: "UPS",
          Id: 2,
        },
      ],
      logisticTypes: [],

      orderPaymentStatus: null,
      orderPaymentStatuses: [
        {
          name: this.$t("labels.All"),
          value: -1,
        },
        {
          name: this.$t("labels.paymentCompleted"),
          value: 0,
        },
        {
          name: this.$t("labels.paymentIncomplete"),
          value: 1,
        },
        {
          name: this.$t("messages.waitingForPaymentApproval"),
          value: 2,
        },
        {
          name: this.$t("messages.extraPayment"),
          value: 3,
        },
        {
          name: this.$t("messages.returnPayment"),
          value: 4,
        },
      ],

      customerName: null,

      orderStatus: null,
      orderStatuses: [],

      orderType: -1,
      orderTypes: [
        {
          name: this.$t("labels.All"),
          value: -1,
        },
        {
          name: "Manuel",
          value: 0,
        },
        {
          name: "Etsy",
          value: 1,
        },
        {
          name: "Amazon",
          value: 2,
        },
      ],

      shipmentCreateType: null,
      shipmentCreateTypes: [
        {
          name: this.$t("labels.All"),
          value: -1,
        },
        {
          name: this.$t("labels.priceSearch"),
          value: 0,
        },
        {
          name: this.$t("labels.spotOfferLabel"),
          value: 1,
        },
        {
          name: this.$t("navigationDrawerMenu.publicApi"),
          value: 2,
        },
      ],

      isPlanned: -1,

      isRunningMode: false,
      debounceTimeout: null,
      query: {
        data: [],
        loading: false,
        page: 1,
        pageSize: 15,
        onChange: () => {
          this.runQuery();
        },
        totalItems: 0,
      },
    };
  },
  components: { FormElement, RefreshButton, TabScreen, CheckTable },
  mounted() {
    this.itemsPerPageOptions = ITEMS_PER_PAGE_OPTIONS;
    this.setup();

    this.isSupplier = this.$store.state.Type === "Supplier";
    this.companyCategory =
      this.$store.state.Type === "Admin" ? null : this.isSupplier ? 3 : 1;

    this.getViewHeaders();
  },
  watch: {
    sampleModal(newValue) {
      if (!newValue) {
        this.viewName = null;
      }
    },
    actionsModal(newValue) {
      if (!newValue) {
        this.$refs.actionsOnExhangeRateObserver.reset();
        this.form = {
          CompanyCategory: null,
        };
        this.isEditMode = false;

        this.query.data = [];
      }
    },
  },
  computed: {
    queryPageLength() {
      return Math.ceil(this.query.totalItems / this.query.pageSize);
    },
    viewRows() {
      if (this.query.data.length > 0 && !this.viewName) return this.query.data;

      if (this.viewHeaders?.length === 0) return [];

      return this.viewHeaders[this.viewName]?.Rows || [];
    },

    selectedViewHeaders() {
      const firstObject = this.viewRows[0];

      if (!firstObject) return [];

      return Object.keys(firstObject).map((header) => ({
        text: header,
        value: header,
        sortable: false,
        groupable: false,
        cellClass: "regular-cell",
        align: "center",
      }));
    },

    viewNames() {
      if (this.viewHeaders?.length === 0) return [];

      return Object.keys(this.viewHeaders).map((key) => ({
        name: this.viewHeaders[key]?.View,
        value: key,
      }));
    },

    formItems() {
      return [
        {
          key: {
            parent: "form",
            child: "Name",
          },
          rules: "required",
          validationLabel: "labels.name",
          formType: {
            name: "text",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.name",
        },
        {
          key: {
            parent: "form",
            child: "CompanyCategory",
          },
          validationLabel: "labels.companyType",
          formType: {
            name: "select",
            items: {
              data: this.$companyCategories,
              text: "name",
              value: "value",
            },
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.companyType",
        },
        {
          key: {
            parent: "form",
            child: "SQL",
          },
          rules: "required",
          validationLabel: "labels.sql",
          formType: {
            name: "textarea",
            append: "mdi-database-search",
          },
          lg: 12,
          labelShown: false,
          topLabel: true,
          cols: 12,
          placeholder: "labels.sql",
        },
      ];
    },

    pageLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    getSearchDebounced() {
      if (!this.customerName) return;
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.query.totalItems = 15;
        this.query.pageSize = 15;
        this.query.page = 1;

        this.runQuery();
      }, 300);
    },
    onLogisticChange() {
      if (!this.integrationLogisticType) {
        this.runQuery();
        return;
      }

      this.$store.state.loadingStatus = true;
      PortalService.getIntegrationServices(this.integrationLogisticType)
        .then((response) => {
          this.logisticTypes = response.data;
        })
        .catch((err) => {
          window.showError(err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.runQuery();
        });
    },

    showDetail(item) {
      this.selectedItem = item;
      this.runQuery(item.Id).then(() => {
        this.showItem = true;
      });
    },

    async runQuery() {
      this.$store.state.loadingStatus = true;
      try {
        try {
          const response = await AdminReportService.getReportResults({
            ReportId: this.selectedItem.Id,
            Page: this.query.page,
            PageSize: this.query.pageSize,
            StartDate: this.startDate,
            EndDate: this.endDate,
            SenderCountryId: this.senderCountryId,
            SenderCityId: this.senderCityId,
            ReceiverCountryId: this.receiverCountryId,
            ReceiverCityId: this.receiverCityId,
            IntegrationLogisticType: this.integrationLogisticType,
            OrderStatus: this.orderStatus,
            ExpressServiceType: this.integrationLogisticSubType,
            OrderPaymentStatus: this.orderPaymentStatus,
            CustomerName: this.customerName,
            OrderType: this.orderType,
            ShipmentCreateType: this.shipmentCreateType,
            IsPlanned: this.isPlanned,
          });
          const data = response.data.Result;
          if (data) {
            this.query.data = data.Data;
            this.query.sql = data.SqlQuery;
            this.query.totalItems = response.data.TotalItems;
            this.showShipmentFilters = data.ShowShipmentFilters !== false;
          }
        } catch (err) {
          console.error("runQuery error:", err);
          window.showError(err);
        }
      } finally {
        this.$store.state.loadingStatus = false;
      }
    },

    download(item) {
      this.$store.state.loadingStatus = true;
      const params = {
        ReportId: this.selectedItem.Id,
        Page: this.query.page,
        PageSize: this.query.pageSize,
        StartDate: this.startDate,
        EndDate: this.endDate,
        SenderCountryId: this.senderCountryId,
        SenderCityId: this.senderCityId,
        ReceiverCountryId: this.receiverCountryId,
        ReceiverCityId: this.receiverCityId,
        IntegrationLogisticType: this.integrationLogisticType,
        OrderStatus: this.orderStatus,
        ExpressServiceType: this.integrationLogisticSubType,
        OrderPaymentStatus: this.orderPaymentStatus,
        CustomerName: this.customerName,
        OrderType: this.orderType,
        ShipmentCreateType: this.shipmentCreateType,
        IsPlanned: this.isPlanned,
      };
      
      AdminReportService.downloadExcels({ ...params, SqlQuery: item?.SQL})
        .then((response) => {
          const data = response.data;
          if (data) {
            downloadFile(data, `${Date.now()}_SQLReport_${item?.Id}`, "xlsx");
          }
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    getRowValue(item, row) {
      if (!item || !row) return;

      const rowValue = item[row["text"]];
      const type = typeof rowValue;
      let value = rowValue;

      if (type === "object") {
        value = "-";
      } else if (type === "string") {
        const isLikelyDate =
          /^(\d{4}-\d{2}-\d{2}(T.*Z)?)$|^(\d{2}\.\d{2}\.\d{4})$/.test(rowValue);
        if (isLikelyDate) {
          value = convertToLocal(rowValue);
        }
      }

      return value;
    },
    async runQueryInline() {
      if (!this.form.SQL) return;

      this.query.loading = true;
      AdminReportService.getSqlResults({
        SQL: this.form.SQL?.trim(),
        Page: this.query.page,
        PageSize: 5,
      })
        .then((response) => {
          const data = response.data.Result;
          if (data) {
            this.query.data = data;
            this.query.totalItems = response.data.TotalItems;
          }
        })
        .catch(window.showError)
        .finally(() => {
          this.query.loading = false;
        });
    },
    async getViewHeaders() {
      this.$store.state.loadingStatus = true;
      AdminReportService.getViewHeaders()
        .then((response) => {
          this.viewHeaders = response.data.Result;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    editItem(item) {
      this.actionsModal = true;
      this.isEditMode = true;

      this.form = Object.assign({}, item);
    },
    deleteItem(id) {
      this.$store.state.loadingStatus = true;
      AdminReportService.delete(id)
        .then((response) => {
          window.showSuccess(this.$t("messages.successfulDelete"));
          this.getItems();
        })
        .catch(window.showError)
        .finally(() => (this.$store.state.loadingStatus = false));
    },

    changeItemsPerPage() {
      this.page = 1;
      this.getItems();
    },

    /**
     * Trigger when page changed.
     */
    onPageChange() {
      this.getItems();
    },

    async getCompanies() {
      this.$store.state.loadingStatus = true;
      AnnouncementService.getCompaniesForAnnouncements()
        .then((response) => {
          const data = response.data;
          if (data) {
            this.companies = response.data.Result;
          }
        })
        .catch(window.showError)
        .finally(() => (this.$store.state.loadingStatus = false));
    },

    async handleCountryChange(isSender) {
      const selectedCountryId = isSender
        ? this.senderCountryId
        : this.receiverCountryId;

      if (!selectedCountryId) {
        if (isSender) {
          this.senderCityId = null;
          this.senderCities = [];
        } else {
          this.receiverCityId = null;
          this.receiverCities = [];
        }

        await this.runQuery();
        return;
      }

      const cities = await getCities(selectedCountryId);

      if (isSender) {
        this.senderCities = cities;
        this.senderCityId = null;
      } else {
        this.receiverCities = cities;
        this.receiverCityId = null;
      }

      this.runQuery();
    },

    async setup() {
      this.getItems();

      const countries = await getCountries();
      this.senderCountries = countries;
      this.receiverCountries = countries;

      this.orderStatuses = [
        {
          name: this.$t("labels.All"),
          value: null,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.detail"),
          value: 0,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.payment"),
          value: 2,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.paymentApproved"),
          value: 1,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.approved"),
          value: 3,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.loaded"),
          value: 4,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.shipping"),
          value: 5,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.inDestination"),
          value: 6,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.delivered"),
          value: 7,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.archived"),
          value: 8,
        },
        {
          name: this.$t("labels.labelsOrderStatuses.canceled"),
          value: 9,
        },
      ];

      this.headers = [
        {
          text: this.$t("labels.name"),
          value: "Name",
          sortable: false,
          groupable: false,
          cellClass: "regular-cell",
          align: "center",
        },
        {
          text: this.$t("labels.sql"),
          value: "SQL",
          sortable: false,
          groupable: false,
          cellClass: "regular-cell",
        },
        {
          text: this.$t("labels.companyCategory"),
          value: "companyCategory",
          sortable: false,
          groupable: false,
          cellClass: ["regular-cell"],
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
        },
      ];
    },

    /**
     * Get search history from service.
     */
    getItems() {
      this.$store.state.loadingStatus = true;
      AdminReportService.getAll({
        Page: this.page,
        PageSize: this.itemsPerPage,
        CompanyCategory: this.companyCategory,
      })
        .then((response) => {
          this.items = response.data.Result;
          this.totalItems = response.data.TotalItems;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    async submitForm() {
      this.$store.state.loadingStatus = true;

      let body = this.form,
        requestFunction = null;

      try {
        requestFunction =
          AdminReportService[this.isEditMode ? "update" : "add"];

        if (requestFunction) {
          requestFunction(body)
            .then((response) => {
              window.showSuccess(
                this.$t(
                  `messages.${
                    this.isEditMode
                      ? "successfulUpdateGeneral"
                      : "successfulAddGeneral"
                  }`
                )
              );
              this.actionsModal = false;
              this.getItems();

              this.file = {
                data: null,
                url: "",
              };
            })
            .catch(window.showError)
            .finally(() => {
              this.$store.state.loadingStatus = false;
            });
        }
      } catch (error) {
        window.showError(error);
      }
    },
  },
};
</script>
<style></style>
